<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-lg-12 margin-tb" style="margin-top:-40px">
                <div class="pull-left">
                    <h2>Users Management</h2>
                </div>
                <div class="pull-right">
                    <button class="btn btn-edit" style="margin-top:20px" @click="$router.go(-1)">Back</button>
                </div>
                <!-- <div class="pull-right">
                    <router-link class="btn btn-success" :to="{ name:'building', params:{ routeName:this.$route.name  } }"> Create New Building</router-link>
                </div> -->
            </div>
        </div>

        <div v-if="message" class="alert alert-success">
            <p>{{ message }}</p>
        </div>

        <table class="table table-striped table-condensed table-border">
            <thead class="thead-style">
            <th>No</th>
            <th>Name</th>
            <th>Number</th>
            <th>Street</th>
            <th>City</th>
            <th>PostCode</th>
            <th width="280px" colspan="2">Action</th>
            </thead>
            <tbody>
                <tr v-for="building, key in buildings">
                    <td>{{ ++key }}</td>
                    <td>{{ building.name }}</td>
                    <td>{{ building.number }}</td>
                    <td>{{ building.streetName }}</td>
                    <td>{{ building.city }}</td>
                    <td>{{ building.postCode }}</td>
                    <td>
                        <button class="btn btn-primary" @click="cleadData(building)">Clear Data</button>
                    </td>
                    <td>
                        <router-link class="btn btn-primary" :to="{name:'building',params:{id:building.id, name:building.name, routeName:$route.name}}">Edit</router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { userService } from '@/_services';
export default {
    data () {
        return {
            buildings:[],
            message: '',
            userId:0
        }
    },
        mounted() {
            if (!this.$route.params.userId) {
                this.$router.replace({ name: 'users' });
                return;
            }
            this.userId = this.$route.params.userId
       //  this.$store.dispatch('users/getAll').then(users => this.users = users);
            userService.getAllBuildings(this.userId).then(buildings => {
                this.buildings = buildings.buildings
            });
    },
    methods:{
        cleadData(building) {
            alert(building.id)
            this.$http.post('/buildings/data/'+building.id, {
                                id:building.id
                            
                            }).then(() => {
                            alert('Data cleared');
                            }, () => {
                                alert('error')
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                            })
                        }
        }
    
}
</script>